import type { PublicEchoFeedbackRecord } from "@/server/echoFeedback";

export function feedbackReporterLabel(record: PublicEchoFeedbackRecord) {
  return record.reporter.displayName || record.reporter.email || "CRM user";
}
